import { ClientSearch } from "@core/components/client-search";
import { useCallback } from "react";
import { Calendar } from "web-design-system";
import { useNotebookContext } from "./notebook-context";

const presentYear = new Date().getFullYear();

export function TaskCalendar() {
  const { filters, setFilters, clientIds } = useNotebookContext();

  return (
    <div className="flex flex-col gap-7">
      <ClientSearch
        options={{ modal: true }}
        client={filters.client}
        clientIds={clientIds}
        placeholder={clientIds ? "Select member" : "Select client"}
        onSelect={useCallback(
          (client) => {
            setFilters((f) => ({ ...f, client: client ?? null }));
          },
          [setFilters]
        )}
      />
      <Calendar
        mode="single"
        selected={filters.date || undefined}
        onSelect={(d) => d && setFilters((f) => ({ ...f, date: d }))}
        className="p-0 pl-4 w-full"
        yearRange={{ from: presentYear - 2, to: presentYear + 2 }}
      />
    </div>
  );
}
